import { defineMessages } from 'react-intl';

const messages = defineMessages({
  correctedAnswersText: {
    id: 'QuizResult.correctedAnswersText',
    defaultMessage: '{correctNum} of {totalNum} questions answered correctly',
    description: 'Message displayed on quiz result page',
  },
  reachedPointsText: {
    id: 'QuizResult.reachedPointsText',
    defaultMessage:
      'You have reached {userTotalPoints} of {quizPoints} point(s), ({pass}%)',
    description: 'Message displayed on quiz result page',
  },
  studentPassedText: {
    id: 'QuizResult.studentPassedText',
    defaultMessage: '(student passed)',
    description: 'Message displayed on quiz result page',
  },
  studentDidNotPassText: {
    id: 'QuizResult.studentDidNotPassText',
    defaultMessage: '(student did not pass)',
    description: 'Message displayed on quiz result page',
  },
  backToTitle: {
    id: 'QuizResult.backToTitle',
    defaultMessage: 'Back to {name}',
    description: 'Tooltip title displayed on quiz result page',
  },
  resultsTitle: {
    id: 'QuizResult.resultsTitle',
    defaultMessage: ' Results',
    description: 'Text displayed on quiz result page',
  },
  userTimeTitle: {
    id: 'QuizResult.userTimeTitle',
    defaultMessage: 'Your time:',
    description: 'Text displayed on quiz result page',
  },
  restartQuizBtnLabel: {
    id: 'QuizResult.restartQuizBtnLabel',
    defaultMessage: 'Restart quiz',
    description: 'Text displayed on quiz result page',
  },
  restartExamBtnLabel: {
    id: 'QuizResult.restartExamBtnLabel',
    defaultMessage: 'Restart exam',
    description: 'Text displayed on restart button on quiz result page',
  },
  viewQuizReportBtnLabel: {
    id: 'QuizResult.viewQuizReportBtnLabel',
    defaultMessage: 'View Quiz Report',
    description: 'Button label displayed on quiz result page',
  },
  viewExamReportBtnLabel: {
    id: 'QuizResult.viewExamReportBtnLabel',
    defaultMessage: 'View Exam Report',
    description:
      'Button label displayed on view report button on quiz result page',
  },
  goToResultBtnLabel: {
    id: 'QuizResult.goToResultBtnLabel',
    defaultMessage: 'Go to result',
    description: 'Button label displayed on quiz result page',
  },
  nextBtnTooltip: {
    id: 'LessonDetails.nextBtnTooltip',
    defaultMessage: 'Next: {name}',
  },
  dateLabel: {
    id: 'QuizResult.dateLabel',
    defaultMessage: 'Date:',
    description: 'Text displayed on quiz result page',
  },
  quizTimeLabel: {
    id: 'QuizResult.quizTimeLabel',
    defaultMessage: 'Quiz time:',
    description: 'Text displayed on quiz result page',
  },
  examTimeLabel: {
    id: 'QuizResult.examTimeLabel',
    defaultMessage: 'Exam time:',
    description: 'Text displayed in exam report on exam result page',
  },
  pointsInTotalLabel: {
    id: 'QuizResult.pointsInTotalLabel',
    defaultMessage: 'Points in total',
    description: 'Text displayed on quiz result page',
  },
  passRequirermentLabel: {
    id: 'QuizResult.passRequirermentLabel',
    defaultMessage: 'Pass requirement {perc}%',
    description: 'Text displayed on quiz result page',
  },
  numberOfAttemptsLabel: {
    id: 'QuizResult.numberOfAttemptsLabel',
    defaultMessage: 'Number of attempts',
    description: 'Text displayed on quiz result page',
  },
  progressLabel: {
    id: 'QuizResult.progressLabel',
    defaultMessage: 'Progress',
    description: 'Text displayed on quiz result page',
  },
  studentLabel: {
    id: 'QuizResult.studentLabel',
    defaultMessage: 'Student',
    description: 'Text displayed on quiz result page',
  },
  meLabel: {
    id: 'QuizResult.meLabel',
    defaultMessage: 'Me',
    description: 'Text displayed on quiz result page',
  },
  answerLabel: {
    id: 'QuizResult.answerLabel',
    defaultMessage: 'answer',
    description: 'Text displayed on quiz result page',
  },
  myGroupLabel: {
    id: 'QuizResult.myGroupLabel',
    defaultMessage: 'My group',
  },
  questionsLabel: {
    id: 'QuizResult.questionsLabel',
    defaultMessage: 'Questions',
    description: 'Text displayed on quiz result page',
  },
  correctLabel: {
    id: 'QuizResult.correctLabel',
    defaultMessage: 'Correct',
    description: 'Text displayed on quiz result page',
  },
  reflectionNoteLabel: {
    id: 'QuizResult.reflectionNoteLabel',
    defaultMessage: 'Question note:',
    description: 'Text displayed on quiz result page',
  },
  pointsLabel: {
    id: 'QuizResult.pointsLabel',
    defaultMessage: 'Points',
    description: 'Text displayed on quiz result page',
  },
  completedItemsInSection: {
    id: 'QuizResult.completedItemsInSection',
    defaultMessage:
      'Completed {completedLessons} lesson(s) and {completedQuizzes} quiz(zes) of {totalLessons} total lesson(s) and {totalQuizzes} total quiz(zes) in the section',
    description: 'Tooltip label displayed on quiz result page',
  },
  showCertificateBtnLabel: {
    id: 'LessonDetails.showCertificateBtnLabel',
    defaultMessage: 'Show course certificate',
    description: 'Button shown when course is completed',
  },
  showExamCertificateBtnLabel: {
    id: 'QuizResult.showExamCertificateBtnLabel',
    defaultMessage: 'Show exam certificate',
    description: 'Button shown when exam is passed',
  },
  tasksLabel: {
    id: 'LessonDetails.tasksLabel',
    defaultMessage: 'tasks',
  },
  taskResultsLabel: {
    id: 'LessonDetails.taskResultsLabel',
    defaultMessage: 'task results',
  },
  trueValue: {
    id: 'QuizResult.trueValue',
    defaultMessage: 'True',
  },
  falseValue: {
    id: 'QuizResult.falseValue',
    defaultMessage: 'False',
  },
  examLabel: {
    id: 'QuizResult.examLabel',
    defaultMessage: 'Exam',
  },
  resultsLabel: {
    id: 'QuizResult.resultsLabel',
    defaultMessage: 'results',
  },
  issueCertificate: {
    id: 'QuizResult.issueCertificate',
    defaultMessage: 'Issue certificate',
  },
  alterToMaxScoreAndAssignCertificate: {
    id: 'QuizResult.alterToMaxScoreAndAssignCertificate',
    defaultMessage: 'Alter to max score, passed and assign certificate',
  },
  alterToNotPassedAndRevokeCertificate: {
    id: 'QuizResult.alterToNotPassedAndRevokeCertificate',
    defaultMessage: 'Alter to not passed and revoke certificate',
  },
  backToTasks: {
    id: 'QuizResult.backToTasks',
    defaultMessage: 'Back to tasks',
  },
  attemptsNumber: {
    id: 'ExamTaskResults.attemptsNumber',
    defaultMessage: 'Number of new retries',
  },
  unlockExamLabel: {
    id: 'ExamTaskResults.unlockExamLabel',
    defaultMessage: 'Unlock',
    description:
      'Button label for unlock exam for user displayed in table column on exam task results page',
  },
  availableLabel: {
    id: 'ExamTaskResults.availableLabel',
    defaultMessage: 'open',
    description:
      'Label for available exam displayed in table on exam task results page',
  },
  statusLabel: {
    id: 'ExamTaskResults.statusLabel',
    defaultMessage: 'Status',
    description:
      'Label for exam status displayed in table on exam task results page',
  },
  quizSessionIsNotEnded: {
    id: 'ExamTaskResults.quizSessionIsNotEnded',
    defaultMessage:
      "Exam session is still going, answers will become available once it's finished by user or automatically after {timeEnd}",
  },
  notStartedLabel: {
    id: 'ExamTaskResults.notStartedLabel',
    defaultMessage: 'not started',
  },
  finished: {
    id: 'ExamTaskResults.finished',
    defaultMessage: 'finished',
  },
  nextBtnLabel: {
    id: 'LessonDetails.nextBtnLabel',
    defaultMessage: 'Next',
  },
  mathQuestionNotAllowedDecimalsHint: {
    id: 'QuizResult.mathQuestionNotAllowedDecimalsHint',
    defaultMessage: '(Decimals in the answer are not allowed)',
  },
  mathQuestionAllowedDecimalsHint: {
    id: 'QuizResult.mathQuestionAllowedDecimalsHint',
    defaultMessage:
      '(Required {allowedDecimals} {allowedDecimals, plural, one {sign} other {signs}} after the comma)',
  },
});

export default messages;
